// extracted by mini-css-extract-plugin
module.exports = {"Page":"_10lN00WtAgz7dNqwWqimQ7","Full":"_1ky7AfuS3cecrl7rEizEtz","TestContainer":"_1zPSyEAc07_Qqq_PacvjWj","Frame":"_27umM7Ksyuxz05UrwO31u-","Center":"e-xosgOuNE2QG7Vitp78T"};